import { translation } from 'I18n/i18n'
import ButtonsContainer from 'components/buttons/buttonsContainer'
import ChangeLanguage from 'components/changeLanguage/changeLanguage'
import Counter from 'contexts/counter'
import HeadbandContext from 'contexts/headband'
import { useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Colors } from 'styles/colors'
import '../accueil/accueil.scss'
export default function Visiteur() {
   const lang = useSelector((state: any) => state.languageReducer.language)
   const { setCounter, counterDefault } = useContext(Counter)
   const { setHeadband } = useContext(HeadbandContext)
   const [buttons, setButtons] = useState([
      {
         title: translation(lang, 'visiteur', 'btn1'),
         titleForCrumb: translation(lang, 'visiteur', 'btn1bis'),
         titleColor: Colors.white,
         bckType: 'color',
         background: Colors.corail,
         border: `${Colors.white} 1px solid`,
         borderRadius: '12px',
         page: '/accueil/visiteur/groupe',
         right: '600px',
         delay: '0',
         size: '200px',
      },
      {
         title: translation(lang, 'visiteur', 'btn2'),
         titleColor: Colors.white,
         bckType: 'color',
         background: Colors.corail,
         border: `${Colors.white} 1px solid`,
         borderRadius: '12px',
         page: '/accueil/visiteur/siteNeubourg',
         top: '-600px',
         delay: '0',
         size: '200px',
      },
      {
         title: translation(lang, 'visiteur', 'btn3'),
         titleColor: Colors.white,
         bckType: 'color',
         background: Colors.corail,
         border: `${Colors.white} 1px solid`,
         borderRadius: '12px',
         page: '/accueil/visiteur/gamme',
         right: '600px',
         delay: '100',
         size: '200px',
      },
      {
         title: translation(lang, 'visiteur', 'btn4'),
         titleForCrumb: translation(lang, 'visiteur', 'btn5bis'),
         titleColor: Colors.white,
         bckType: 'color',
         background: Colors.corail,
         border: `${Colors.white} 1px solid`,
         borderRadius: '12px',
         page: '/accueil/visiteur/hse',
         delay: '100',
         size: '200px',
      },
      {
         title: translation(lang, 'visiteur', 'btn5'),
         titleForCrumb: translation(lang, 'visiteur', 'btn6bis'),
         titleColor: Colors.white,
         bckType: 'color',
         background: Colors.corail,
         border: `${Colors.white} 1px solid`,
         borderRadius: '12px',
         page: '/accueil/visiteur/qualite',
         right: '-600px',
         delay: '100',
         size: '200px',
      },
      {
         title: translation(lang, 'visiteur', 'btn6'),
         titleColor: Colors.white,
         bckType: 'color',
         background: Colors.corail,
         border: `${Colors.white} 1px solid`,
         borderRadius: '12px',
         page: '/accueil/visiteur/environnement',
         top: '600px',
         delay: '200',
         size: '200px',
      },
      {
         title: translation(lang, 'visiteur', 'btn7'),
         titleColor: Colors.white,
         bckType: 'color',
         background: Colors.rouge,
         border: `${Colors.white} 1px solid`,
         borderRadius: '12px',
         page: '/accueil/visiteur/urgence',
         top: '600px',
         delay: '200',
         size: '200px',
      },
   ])
   useEffect(() => {
      setCounter(counterDefault)
      setHeadband('')
      // console.log(getItem('totem'))
      // if (getItem('totem') === 'Showroom') {
      //    const beleanButton = {
      //       title: 'BE LEAN +',
      //       titleColor: Colors.white,
      //       bckType: 'color',
      //       background: Colors.gris1,
      //       border: `${Colors.white} 1px solid`,
      //       borderRadius: '12px',
      //       page: '/accueil/visiteur/projets',
      //       top: '600px',
      //       delay: '200',
      //       size: '200px',
      //    }
      //    setButtons((prev) => [...prev, beleanButton])
      // }
   }, [])

   useEffect(() => {
      setButtons((prevButtons) =>
         prevButtons.map((button, index) => {
            const updatedButton = { ...button }
            switch (index) {
               case 0:
                  updatedButton.title = translation(lang, 'visiteur', 'btn1')
                  updatedButton.titleForCrumb = translation(lang, 'visiteur', 'btn1bis')
                  break
               case 1:
                  updatedButton.title = translation(lang, 'visiteur', 'btn2')
                  break
               case 2:
                  updatedButton.title = translation(lang, 'visiteur', 'btn3')
                  break
               case 3:
                  updatedButton.title = translation(lang, 'visiteur', 'btn4')
                  updatedButton.titleForCrumb = translation(lang, 'visiteur', 'btn5bis')
                  break
               case 4:
                  updatedButton.title = translation(lang, 'visiteur', 'btn5')
                  updatedButton.titleForCrumb = translation(lang, 'visiteur', 'btn6bis')
                  break
               case 5:
                  updatedButton.title = translation(lang, 'visiteur', 'btn6')
                  break
               case 6:
                  updatedButton.title = translation(lang, 'visiteur', 'btn7')
                  break
            }
            return updatedButton
         }),
      )
   }, [lang])
   return (
      <>
         <div className='flex column around'>
            <div id='carousel'>
               <ChangeLanguage />
               <div style={{ width: 1080, height: 607 }}>
                  <img src={`${process.env.PUBLIC_URL}/img/visiteur.jpg`} alt='' />
               </div>
            </div>
            <ButtonsContainer buttons={buttons} />
         </div>
      </>
   )
}
